import { CharReveal, formatClock, formatDay, formatInt, nightWindow } from '../index.js';

import type { StyleWithVars } from '../index.js';
import type { PartyWrapped } from '@mixwire/contracts';
import type { CSSProperties, ReactElement } from 'react';

type Slide01IntroProps = {
  readonly wrapped: PartyWrapped;
};

const WINDOW_STYLE: StyleWithVars = { '--d': '100' };
const TITLE_STYLE: CSSProperties = { fontSize: '11cqw' };
const LEDE_STYLE: StyleWithVars = { '--d': '1400' };
const HINT_STYLE: StyleWithVars = { '--d': '2300' };

const describeWindow = (createdAt: string, endMs: number | null): string => {
  const started = new Date(createdAt);
  const day = `${formatDay(started)}, ${formatClock(started)}`;

  return endMs === null ? `${day}, still going` : `${day} to ${formatClock(new Date(endMs))}`;
};

export const Slide01Intro = ({ wrapped }: Slide01IntroProps): ReactElement => {
  const { party, djCount, tokenCount, trackCount } = wrapped;
  const { endMs } = nightWindow(wrapped);

  return (
    <>
      <p className="lede rise" style={WINDOW_STYLE}>
        {describeWindow(party.createdAt, party.endedAt === null ? null : endMs)}
      </p>
      <h1 className="big" style={TITLE_STYLE}>
        <CharReveal text={party.displayName} delayMs={300} />
      </h1>
      {djCount === 0 && tokenCount === 0 ? (
        <p className="lede rise" style={LEDE_STYLE}>
          Three channels, nobody behind them and no phones on the request page. Here is the night
          anyway.
        </p>
      ) : (
        <p className="lede rise" style={LEDE_STYLE}>
          <b>{formatInt(djCount)}</b> {djCount === 1 ? 'DJ' : 'DJs'}, three channels and{' '}
          <b>{formatInt(tokenCount)}</b> {tokenCount === 1 ? 'phone' : 'phones'} on the request
          page. {trackCount === 0 ? 'Here is the night anyway.' : 'Here is how the night sounded.'}
        </p>
      )}
      <p className="hint rise" style={HINT_STYLE}>
        Tap the right side to continue, hold to pause.
      </p>
    </>
  );
};
